/**
 * 求人検索ページ
 */

class JobSearch {
    constructor() {
        // ページ初期化
        this.searcbBox();

        // 地域検索 親チェックON、OFFで子チェックも変更
        this.childCheckEls = document.querySelectorAll('.child-check');
        this.childCheckEls.forEach(el => el.addEventListener('change', () => this.checkAllChild(el)));

        // 地域検索 子チェックON、OFFで親チェックも変更
        this.parentCheckEls = document.querySelectorAll('.area_children input');
        this.parentCheckEls.forEach(el => el.addEventListener('change', () => this.checkParent(el)));

        // 地域検索　子要素表示・非表示の初期化
        this.toggleAreaChildren();
    }

    /**
     * ページ初期化時に実行
     */
    searcbBox(){
        const elements = document.querySelectorAll('.searchBox dt');

        // 検索ボックス初期設定
        let index = 0;
        for( let element of elements ){
            const storageValue = localStorage.getItem('search_box_'+index);
            const toggleBtn = element.querySelector('.toggle-btn');
            index++;

            if( !toggleBtn ) continue;

            if( storageValue && storageValue == 'close' ){
                element.nextElementSibling.style.display = 'none';
                element.querySelector('.toggle-btn').classList.remove('active');
            }

        }

        // 検索ボックススライド
        $('.searchBox dt').on('click', function(){
            $(this).next().slideToggle();
            const elements = document.querySelectorAll('.searchBox dt');
            const index = [].slice.call(elements).indexOf(this);

            if ($(this).children('.toggle-btn').hasClass('active')) {
                $(this).children('.toggle-btn').removeClass('active');
                localStorage.setItem('search_box_'+index, 'close');
            }else {
                $(this).children('.toggle-btn').addClass('active');
                localStorage.setItem('search_box_'+index, 'open');
            }
        });

        // 検索ボックススライド（タイトル）
        $('.sort_ttl').on('click', function() {
            $(this).next().slideToggle();
            $(this).toggleClass("active");

            if ($(this).children('.sp_drop').hasClass('active')) {
                $(this).children('.sp_drop').removeClass('active');
            }else{
                $(this).children('.sp_drop').addClass('active');
            }
        });
    }

    /**
     * 地域検索　子要素表示・非表示の初期化
     */
    toggleAreaChildren(){
        this.childCheckEls.forEach(el => {
            const childUlEl = el.closest('li').querySelector('.area_children');
            const childEls = el.closest('li').querySelectorAll('.area_children input');
            const checkedChildEl = el.closest('li').querySelectorAll('.area_children input:checked');

            if( el.checked || checkedChildEl.length > 0 ){
                // childUlEl.style.display = '';
                el.closest('li').style.width = '100%';
            }else{
                // childUlEl.style.display = 'none';
                el.closest('li').style.width = '';
            }
        });
    }

    checkAllChild(el){
        const childEls = el.closest('li').querySelectorAll('.area_children input');
        const childUlEl = el.closest('li').querySelector('.area_children');

        if( el.checked ){
            childEls.forEach(el2 => el2.checked = true);
            el.closest('li').style.width = '100%';
            $(childUlEl).slideDown();
        }else{
            childEls.forEach(el2 => el2.checked = false);
        }
    }

    checkParent(el){
        const parentEl = el.closest('ul').previousElementSibling.querySelector('input');
        const childEl = el.closest('ul').querySelectorAll('input');
        const checkedChildEl = el.closest('ul').querySelectorAll('input:checked');

        if( childEl.length == checkedChildEl.length ){
            parentEl.checked = true;
        }else{
            parentEl.checked = false;
        }
    }

}

const jobSearch = new JobSearch();
